<template>
  <div>
    <div v-for="key in value" :key="key">
      <b-container v-show="isEnvironmentContainerVisible(key)">
        <b-row class="justify-content-md-center">
          <b-col cols="11">
            <b-table v-if="callData[key]"
                     :fields="fields"
                     :items="[callData[key]]"
                     :stacked="true">
              <template v-slot:cell(type)="{}">
                <b-badge variant="info"> {{ key }}</b-badge>
              </template>
              <template v-slot:cell(shifts)="{}">
                <b-form-input v-if="areEnvironmentDataAvailable(key)"
                              v-model="callData[key].shifts"
                              :disabled="isManagementEvaluation"
                              max="999"
                              min="0"
                              placeholder="shift"
                              type="number"
                              @paste.prevent/>
                <span v-else>-</span>
                <p v-if="isLackOfShiftsMessageVisible(key)"
                   class="grey--text mt-2 mb-0">
                  No shifts set for the call yet, please wait or contact User Office.
                </p>
              </template>
              <template v-slot:cell(shifts_management)="{}">
                <b-form-input v-if="areEnvironmentDataAvailable(key)"
                              v-model="callData[key].shifts_management"
                              max="999"
                              min="0"
                              placeholder="shift"
                              type="number"
                              @paste.prevent/>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(shifts_reserve)="{}">
                <b-form-input v-if="areEnvironmentDataAvailable(key)"
                              v-model="callData[key].shifts_reserve"
                              max="999"
                              min="0"
                              placeholder="shift"
                              type="number"
                              @paste.prevent/>
                <span v-else>-</span>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CallData',
    props: {
      value: {
        required: true,
        type: Array,
      },
      callData: {
        required: true,
        type: Object,
      },
      isManagementEvaluation: {
        required: false,
        default: false,
        type: Boolean,
      },
      isManagementEvaluationCryoem: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        currentKey: '',
        fields: [
          'type',
          { key: 'shifts', label: 'Shifts (committee)', tdClass: 'input-label-custom' },
          { key: 'shifts_management', label: 'Shifts (management)', tdClass: 'input-label-custom' },
          { key: 'shifts_reserve', label: 'Shifts (waiting list)', tdClass: 'input-label-custom' },
        ],
        items: [],
      };
    },
    methods: {
      isEnvironmentContainerVisible(key) {
        return !this.isManagementEvaluation
          || (this.isManagementEvaluation && key === 'CRYOEM' && this.isManagementEvaluationCryoem)
          || (this.isManagementEvaluation && key !== 'CRYOEM' && !this.isManagementEvaluationCryoem);
      },
      areEnvironmentDataAvailable(key) {
        return this.callData[key];
      },
      areCommitteeShiftsSet(key) {
        return this.areEnvironmentDataAvailable(key) && this.callData[key].shifts;
      },
      isLackOfShiftsMessageVisible(key) {
        return this.isManagementEvaluation && !this.areCommitteeShiftsSet(key);
      },
    },
  };
</script>

<style lang="scss">
  .table.b-table.b-table-stacked > tbody > tr > [data-label].input-label-custom::before {
    padding-top: .4rem;
  }
</style>
